module.exports = ["internalCombustionEngine", "electricMotor", "turbine"]